import React, { useState, useRef, useEffect } from 'react';
import { FaCube, FaUserCircle, FaCircle, FaUsers, FaBars } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useExchangeRate } from '../ExchangeRateContext';
import { useAuth } from '../contexts/AuthContext';
import RateModal from './RateModal';
import OwnerCredentialsModal from './OwnerCredentialsModal';

const Header = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const userRef = useRef(null);
  const navigate = useNavigate();
  const { rate, date } = useExchangeRate();
  const { user, logout } = useAuth();
  const [showRateModal, setShowRateModal] = useState(false);
  const [showCredsModal, setShowCredsModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (userRef.current && !userRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    if (dropdownOpen) document.addEventListener('mousedown', handleClickOutside);
    else document.removeEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [dropdownOpen]);

  const handleLogout = (e) => {
    e.stopPropagation();
    logout();
    navigate('/login');
  };

  const getUserDisplayName = () => {
    if (!user) return 'User';
    if (user.role === 'staff' && user.fullName) return user.fullName;
    return user.username || 'User';
  };

  return (
    <>
      <header
        className="d-flex align-items-center justify-content-between bg-light border-bottom px-3 px-md-4 py-2 flex-wrap"
        style={{ minHeight: 64, position: 'sticky', top: 0, zIndex: 900 }}
      >
        {/* Left: Logo + Mobile Toggle */}
        <div className="d-flex align-items-center gap-2">
          {/* Mobile menu toggle */}
          <button
            className="btn btn-light d-md-none border-0 p-1 me-2"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <FaBars size={22} />
          </button>

          {/* Logo */}
          <div className="d-none d-md-flex align-items-center gap-2">
            <img
              src="./logo.png"
              alt="Bi POS logo"
              className="rounded-circle border border-2 border-success"
              style={{ width: 40, height: 40, objectFit: 'cover' }}
            />
            <span
              className="fw-bold fs-4 mb-0"
              style={{
                fontFamily: 'Montserrat, Poppins, sans-serif',
                color: 'var(--main-color)',
                textShadow: '0 2px 3px rgba(2, 100, 25, 0.35)',
              }}
            >
              Bi POS
            </span>
          </div>
        </div>

        {/* Center: Exchange Rate (Responsive) */}
        <div
          className="bg-white border rounded-pill px-2 px-md-3 py-1 text-nowrap flex-shrink-1"
          style={{
            fontSize: 'clamp(12px, 1.5vw, 14px)',
            cursor: 'pointer',
            minWidth: 120,
            textAlign: 'center',
          }}
          onClick={() => setShowRateModal(true)}
        >
          <b>{rate ? rate.toFixed(2) : '...'} UZS</b> / {date || '...'}
        </div>

        {/* Right: User Menu */}
        <div
          className="d-flex align-items-center gap-2 mt-2 mt-md-0"
          ref={userRef}
          style={{ position: 'relative', cursor: 'pointer' }}
          onClick={() => setDropdownOpen((open) => !open)}
        >
          <FaUserCircle size={32} className="text-secondary" />
          <span className="d-none d-sm-inline">{getUserDisplayName()}</span>
          <FaCircle size={12} className="text-success ms-1" />
          {dropdownOpen && (
            <div
              style={{
                position: 'absolute',
                top: '110%',
                right: 0,
                background: 'white',
                border: '1px solid #ddd',
                borderRadius: 8,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                minWidth: 140,
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  padding: '8px 16px',
                  borderBottom: '1px solid #eee',
                  fontSize: '12px',
                  color: '#666',
                }}
              >
                {user?.role?.toUpperCase() || 'USER'}
              </div>
              <button
                style={{
                  width: '100%',
                  padding: '8px 16px',
                  background: 'none',
                  border: 'none',
                  textAlign: 'left',
                  cursor: 'pointer',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowCredsModal(true);
                }}
              >
                Sozlash
              </button>
              <button
                style={{
                  width: '100%',
                  padding: '8px 16px',
                  background: 'none',
                  border: 'none',
                  textAlign: 'left',
                  cursor: 'pointer',
                  color: 'red',
                }}
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </header>

      {/* Modals */}
      <RateModal show={showRateModal} onClose={() => setShowRateModal(false)} />
      <OwnerCredentialsModal show={showCredsModal} onClose={() => setShowCredsModal(false)} />
    </>
  );
};

export default Header;
